import { render, staticRenderFns } from "./Dishes.vue?vue&type=template&id=41c9512e&scoped=true"
import script from "./Dishes.vue?vue&type=script&lang=js"
export * from "./Dishes.vue?vue&type=script&lang=js"
import style0 from "./Dishes.vue?vue&type=style&index=0&id=41c9512e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c9512e",
  null
  
)

export default component.exports